import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import BillingAmountTable from "components/pages/billingAmount/BillingAmountTable";
import BillingAmountModal from "components/pages/billingAmount/modal/BillingAmountModal";

import "pages/billingAmount/billingAmount.css";
import { setTitle } from "app/store/transmission/slice/transmissionSlice";

const BillingAmount = () => {
  const { selectedBillingAmount } = useSelector((state) => state.billingAmount);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setTitle({
        title: "Billing Amount",
      })
    );
  }, [dispatch]);

  return (
    <>
      {selectedBillingAmount && <BillingAmountModal />}

      <BillingAmountTable />
    </>
  );
};

export default BillingAmount;
